import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/builds/robustastudio/midea/miraco-website/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/robustastudio/midea/miraco-website/layouts/default.vue").then(m => m.default || m)),
  minimal: defineAsyncComponent(() => import("/builds/robustastudio/midea/miraco-website/layouts/minimal.vue").then(m => m.default || m)),
  "svg-sprite": defineAsyncComponent(() => import("#build/svg-sprite.vue").then(m => m.default || m))
}